module.exports = __webpack_public_path__ + "addepar.cb6ef70efc00f2fb638654004ba40b25.svg";